import { combineReducers } from 'redux';
import { union } from 'lodash';
import {
  GET_RESULT_SUCCESS,
  GET_RESULT_FAILURE,
  SET_RESULT,
  CREATE_RESULT_SUCCESS,
  GET_RESULT_USER_SUCCESS,
} from 'actionTypes';

function resultsReducerById(state = {}, action) {
  const { type, result, resultUUID } = action;
  switch (type) {
    case SET_RESULT:
    case GET_RESULT_SUCCESS:
    case GET_RESULT_FAILURE:
    case CREATE_RESULT_SUCCESS:
      return {
        ...state,
        [result.uuid]: {
          ...state[result.uuid],
          ...result,
        },
      };
    case GET_RESULT_USER_SUCCESS:
      return {
        ...state,
        [resultUUID]: {
          ...state[resultUUID],
          user: action.normalizedData.result,
        },
      };
    default:
      return state;
  }
}

function resultsReducerAllIds(state = [], action) {
  const { type, result } = action;
  switch (type) {
    case SET_RESULT:
    case GET_RESULT_SUCCESS:
    case CREATE_RESULT_SUCCESS:
      return union(state, [result.uuid]);
    default:
      return state;
  }
}

export default combineReducers({
  byId: resultsReducerById,
  allIds: resultsReducerAllIds,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/resultsReducer.js